import { useState } from 'react';

import './auth.css';

/**
 * Задать пароль по одноразовой ссылке.
 *
 * Сюда ведут две ссылки: «забыли пароль» и «задайте пароль» после того, как
 * чат завели одной кнопкой из кабинета платформы продаж (пароль платформы
 * скопировать нельзя — она хранит лишь его отпечаток). После сохранения —
 * на вход с уже подставленными пространством и почтой.
 */
export function ResetPasswordPage(): JSX.Element {
  const query = new URLSearchParams(window.location.search);
  const token = query.get('token') ?? '';
  const workspace = query.get('workspace') ?? '';
  const email = query.get('email') ?? '';
  const isSetup = query.get('setup') === '1';

  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    if (password.length < 8) return setError('Пароль — не короче 8 символов');
    if (password !== repeat) return setError('Пароли не совпадают');
    setPending(true);
    try {
      const res = await fetch('/api/v1/auth/reset-password', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      if (!res.ok) {
        const body = (await res.json().catch(() => null)) as { error?: { message?: string } } | null;
        throw new Error(body?.error?.message ?? `не удалось сохранить (${res.status})`);
      }
      const next = new URLSearchParams({ ...(workspace ? { workspace } : {}), ...(email ? { email } : {}) });
      window.location.assign(`/login?${next.toString()}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'не удалось сохранить');
      setPending(false);
    }
  }

  return (
    <div className="inbx-auth-page">
      <form className="inbx-auth-form" onSubmit={(e) => void onSubmit(e)}>
        <h1 className="inbx-auth-title">{isSetup ? 'Пароль для чата' : 'Новый пароль'}</h1>
        {isSetup && (
          <p style={{ margin: 0 }}>
            Пространство уже создано. Задайте пароль, чтобы входить в чат напрямую — из кабинета
            платформы он открывается и без него.
          </p>
        )}
        {email && (
          <p style={{ margin: 0 }}>
            Логин: <b>{email}</b>
            {workspace && (
              <>
                , пространство: <b>{workspace}</b>
              </>
            )}
          </p>
        )}
        {!token ? (
          <div className="inbx-auth-error">Ссылка неполная — откройте её из письма или кабинета заново.</div>
        ) : (
          <>
            <label>
              Пароль
              <input
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
            </label>
            <label>
              Ещё раз
              <input
                type="password"
                autoComplete="new-password"
                value={repeat}
                onChange={(e) => setRepeat(e.target.value)}
              />
            </label>
            {error && <div className="inbx-auth-error">{error}</div>}
            <button type="submit" disabled={pending}>
              {pending ? 'Сохраняем…' : 'Сохранить пароль'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
